import { defineEntityContract, type EntityStateEvents } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { FieldSkeleton } from 'shared/types/form';

export type IssueFormEvents = EntityStateEvents & {
  [DomainMessagesTypes.allIssueForm]: { hasAll?: boolean; items: FieldSkeleton[] };
};

/** Fields of the issue form of the selected project; read only. */
export const issueFormContract = defineEntityContract<FieldSkeleton, IssueFormEvents>('issueFormChannel', {
  collectionEvent: DomainMessagesTypes.allIssueForm,
});
